import React from "react";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Calendar, Users } from "lucide-react";
import { translations } from "@/lib/translations";

interface PlanSettingsProps {
  duration?: number;
  servings?: number;
  onDurationChange?: (duration: number) => void;
  onServingsChange?: (servings: number) => void;
}

const PlanSettings = ({
  duration = 7,
  servings = 4,
  onDurationChange = () => {},
  onServingsChange = () => {},
}: PlanSettingsProps) => {
  return (
    <div className="w-full bg-white p-6 rounded-lg">
      <h2 className="text-2xl font-semibold mb-6 text-right">
        {translations.mealPlanner.planSettings.title}
      </h2>

      <div className="space-y-8">
        {/* Duration Setting */}
        <Card className="p-6">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Calendar className="h-5 w-5 text-primary" />
              <Label className="text-lg font-medium">
                {translations.mealPlanner.planSettings.duration}
              </Label>
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">
                  {duration} {translations.mealPlanner.planSettings.days}
                </span>
              </div>

              <Slider
                min={1}
                max={14}
                step={1}
                value={[duration]}
                onValueChange={(value) => onDurationChange(value[0])}
              />

              <div className="flex justify-between text-sm text-muted-foreground">
                <span>1 {translations.mealPlanner.planSettings.day}</span>
                <span>14 {translations.mealPlanner.planSettings.days}</span>
              </div>
            </div>
          </div>
        </Card>

        {/* Servings Setting */}
        <Card className="p-6">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Users className="h-5 w-5 text-primary" />
              <Label className="text-lg font-medium">
                {translations.mealPlanner.planSettings.servings}
              </Label>
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">
                  {servings}{" "}
                  {translations.mealPlanner.planSettings.servingsCount}
                </span>
              </div>

              <Slider
                min={1}
                max={8}
                step={1}
                value={[servings]}
                onValueChange={(value) => onServingsChange(value[0])}
              />

              <div className="flex justify-between text-sm text-muted-foreground">
                <span>1 {translations.mealPlanner.planSettings.serving}</span>
                <span>8 {translations.mealPlanner.planSettings.servings}</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PlanSettings;
